module.exports = __webpack_public_path__ + "static/media/statistics-hero-img-right.4e13b1b8.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/statistics-hero-img-right.png
// module id = 702
// module chunks = 0